import Welcome from './Welcome.jsx';

export default Welcome;
